import { FC, memo, ReactNode, useMemo } from 'react'
import {
  NoteContainerStyles,
  NoteHeaderStyles,
  NoteSubTitleStyles,
  NoteContentStyles,
  NoteNameStyles,
} from './Note.styles'
import Markdown from 'markdown-to-jsx'
import { Link } from '@mui/material'

function isNumeric(str) {
  if (typeof str != 'string') return false
  return (
    // @ts-ignore
    !isNaN(str) && !isNaN(parseFloat(str))
  )
}

const CustomLink = ({
  children,
  title,
  href,
}: {
  children: ReactNode
  title: string
  href: string
}) => {
  const url = useMemo(() => {
    let _url = href
    if (isNumeric(href)) {
      _url = `/admins/${href}`
    }
    return _url
  }, [href])

  return (
    <Link href={url} target="_blank" rel="noopener noreferrer">
      {children || title}
    </Link>
  )
}

const Note: FC<NoteProps> = memo(
  ({
    name,
    dateTime,
    content,
    mentionedName,
    mentionProfileUrl,
  }: NoteProps) => {
    const parsedContent = content.replace(/\n/g, '<br/>')
    return (
      <NoteContainerStyles>
        <NoteHeaderStyles>
          {name}
          <NoteSubTitleStyles>{dateTime}</NoteSubTitleStyles>
        </NoteHeaderStyles>
        <NoteContentStyles>
          {mentionProfileUrl && mentionedName && (
            <NoteNameStyles href={mentionProfileUrl}>
              {mentionedName}
            </NoteNameStyles>
          )}
          <Markdown
            options={{
              overrides: {
                a: {
                  component: CustomLink,
                },
              },
            }}
          >
            {parsedContent}
          </Markdown>
        </NoteContentStyles>
      </NoteContainerStyles>
    )
  },
)

export default Note
